(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.constant:headerMenuIconsPosition
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio')
    .value('headerMenuIconsPosition', "up"); // Opciones: 'up', 'down', 'left' o 'right'.
}());
